import React from "react";
import Sidebar from "src/components/common/Sidebar";
import ContactUsPage from "src/components/cms/ContactUs";
import { RODEO_PAGE_NAME } from "src/_config";
import Footer from "src/components/common/Footer";
import Header from "src/components/common/Header";

export default function ContactUsContainer() {
  return (
    <React.Fragment>
      <Header variant="topbar" />
      <Sidebar page={RODEO_PAGE_NAME.DASHBOARD} />
      <ContactUsPage />
      <Footer variant="dashboard" />
     
    </React.Fragment>
  );
}
